export default __webpack_public_path__ + "static/media/background-top.75be9e03.png";